module.exports = __webpack_public_path__ + "img/upi-autopay.24c43046.svg";